<template>
  <div style="height: 900px" id="perfil_div">
    
    <v-container>
      <v-row>
        <v-col cols="12" md="4">
          <h1 class="headline mb-1">Carpetas</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" v-if="this.$store.state.user.crear_expedientes && this.mostrar_expendientes">
          <v-alert
            type="info"
            dismissible
            v-if="
              this.$store.state.user.crear_expedientes &&
              this.mostrar_expendientes
            "
          >
            Los <strong>expedientes</strong> son
            <strong>carpetas públicas</strong> accesibles para las personas que
            están en su misma organización. Se utilizan para agrupar flujos,
            ciclos o documentos.
          </v-alert>

          <v-alert
            type="info"
            dismissible
            v-if="
              this.$store.state.user.crear_expedientes &&
              this.mostrar_expendientes
            "
          >
            Las <strong>carpetas personales</strong> son
            <strong>privadas</strong> solamente usted las puede ver y le sirven
            para ordenar de mejor forma sus documentos.
          </v-alert>
          <v-alert
            v-if="!this.$store.state.user.crear_expedientes"
            border="top"
            colored-border
            type="error"
            elevation="2"
          >
            
          </v-alert>
       </v-col>  

        <v-col cols="12" md="4">
          <!--<h1 class="headline mb-1">Crear expediente <small style="font-size: 12px">pública</small></h1> -->
          <v-card class="mb-1">
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="nombre_carpeta"
                  label="Nombre"
                  :rules="[rules.required]"
                  prepend-icon="mdi-file-settings-outline"
                  id="inputEmail"
                >
                </v-text-field>

                <v-select
                  v-if="!$store.state.user.crear_expedientes"
                  @change="tipoCarpeta"
                  v-model="tipo_carpeta"
                  :items="tipo_1"
                  :item-text="tipo_1.text"
                  :item-value="tipo_1.value"
                  :rules="[rules.required]"
                  prepend-icon="mdi-folder-outline"
                  label="Tipo de carpeta"
                ></v-select>

                <v-select
                  v-if="$store.state.user.crear_expedientes "
                  @change="tipoCarpeta"
                  v-model="tipo_carpeta"
                  :items="tipo_2"
                  :item-text="tipo_2.text"
                  :item-value="tipo_2.value"
                  :rules="[rules.required]"
                  prepend-icon="mdi-folder-outline"
                  label="Tipo de carpeta"
                ></v-select>

                <v-text-field
                  readonly
                  v-if="tipo_carpeta == 'personal' && !es_principal"
                  v-model="padre_nombre"
                  label="Directorio principal"
                  :rules="[rules.required]"
                  prepend-icon="mdi-folder-account-outline"
                  id="inputEmail"
                >
                </v-text-field>

                <v-checkbox
                  v-if="tipo_carpeta == 'personal'"
                  v-model="es_principal"
                  label="Es principal"
                >
                </v-checkbox>

                <v-treeview
                  dense
                  v-if="tipo_carpeta == 'personal' && !es_principal"
                  v-model="selection"
                  :items="$store.state.user.menu_personal"
                  :selection-type="selectionType"
                  @input="verSeleccion"
                  selectable
                  return-object
                >
                  <template v-slot:label="{ item, open, selected }">
                    {{ item.nombre }}
                  </template>
                </v-treeview>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                :loading="loading"
                :disabled="!valid"
                color="primary"
                id="login"
                class="mr-4"
                @click="validate"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

     <v-row>
      <v-col cols="12" md="4" v-if="!this.$store.state.user.crear_expedientes && this.mostrar_expendientes">
          <v-alert
            type="info"
            dismissible
          >
          <ul>
              <li>No posee permisos para crear expedientes</li>
          </ul>
          </v-alert>
        </v-col>
     </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: function () {
    return {
      mostrar_expendientes: false,
      valid: false,
      nombre_carpeta: "",
      tipo_carpeta: "",
      padre_id: "",
      loading: false,
      padre_nombre: "",
      es_principal: false,
      tipo_1: [{ text: "Personal", value: "personal" }],
      tipo_2: [
        { text: "Personal", value: "personal" },
        { text: "Expediente", value: "publica" },
      ],
      justify: "center",
      alignment: "center",
      rules: {
        required: (value) => !!value || "Requerido",
        min: (v) => v.length >= 8 || "Minimo 8 caracteres",
        emailMatch: () => "The email and password you entered don't match",
      },
      selection: [],
      selectionType: "independent",
      open: ["public"],
    };
  },
  computed: {},
  mounted() {
    $("#inputEmail").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#login").click();
      }
    });
    this.verificar_expedientes();
  },
  methods: {
    async verificar_expedientes() {
      if (this.planes == null) {
        await this.validar();
      }
      let filtrado = this.planes.filter(
        (e) =>
          e.reference == 1 ||
          e.reference == 5 ||
          e.reference == 6 ||
          e.reference == 7 ||
          e.reference == 8 ||
          e.reference == 9 ||
          e.reference == 11 ||
          e.reference == 12 ||
          e.reference == 17 ||
          e.reference == 18 ||
          e.reference == 19 ||
          e.reference == 20 ||
          e.reference == 21 ||
          e.reference == 41 ||
          e.reference == 22 );
      let visible = false;

      visible = !(filtrado.length == 0);

          this.mostrar_expendientes = visible;

      if(this.mostrar_expendientes && this.$store.state.user.crear_expedientes){
         this.tipo_2= [
          { text: "Personal", value: "personal" },
          { text: "Expediente", value: "publica" },
        ]
      }else{
        this.tipo_2 = [
          { text: "Personal", value: "personal" },
        ]
      }
      return true;
    },
    async validar() {
      try {
        const resp = await axios.post(
          "Agrupador/listar_planes_propios",
          { Id: this.$store.state.user.agrupador_id },
          { headers: this.$store.state.user.headers }
        );
        this.planes = resp.data.filter((e) => e.estado == "ACTIVO");
        return this.planes;
      } catch (err) {
        console.log("ERROR EN EL CALLBACK" + erro);
      }
    },
    validate() {
      let _this0 = this;
      if (this.$refs.form.validate()) {
        this.loading = true;
        let padre_id =
          this.tipo_carpeta == "personal"
            ? this.es_principal
              ? null
              : this.padre_id
            : null;
        let url =
          this.tipo_carpeta == "personal"
            ? "Carpeta/Crear"
            : "Carpeta/CrearExpediente";
        let postcarpeta = axios.post(
          url,
          { nombre: this.nombre_carpeta, carpeta_padre_id: padre_id },
          { headers: this.$store.state.user.headers }
        );
        return postcarpeta
          .then((callback) => {
            if (callback.status == 201 || callback.status == 200) {
              let response = {
                expires_in: 7200,
                roles: this.$store.state.user.roles,
                info_firma: this.$store.state.user.info_firma,
                notificaciones_no_leidas:
                  this.$store.state.user.notificaciones_count,
                auth_token:
                  this.$store.state.user.headers.Authorization.replace(
                    "Bearer ",
                    ""
                  ),
              };
              this.$store
                .dispatch("MAIN_MENU", response)
                .then(({ status }) => {
                  this.padre_id = "";
                  this.selection = [];
                  this.$refs.form.reset();
                })
                .catch((errorMenu) => {
                  console.log("MAIN_MENU... error");
                });
              this.$store.dispatch("SHOW_ERROR", {
                show: true,
                type: "success",
                text: "Carpeta creada",
              });
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log(error.response);
            this.loading = false;
          });
      }
    },
    verSeleccion() {
      this.padre_id = "";
      this.padre_nombre = "";
      if (this.selection.length > 0) {
        this.padre_id = this.selection[0].id;
        this.padre_nombre = this.selection[0].nombre;
      }
    },
    tipoCarpeta() {},
  },
};
</script>